
  export default {
    data() {
      return {
        currPage: 1,
      }
    },
    props: {
      rows: {
        type: Number,
        default: 0
      },
      perPage: {
        type: Number,
        default: 0
      }
    },
    watch: {
      currPage() {
        return this.currentPage || 1;
      }
    },
    methods: {
      onChangePaging(page) {
        this.currPage = page
        this.$emit('on-change', page)
      }
    },
  }
